import { defaultHttpClient } from 'shared/src/api/httpClient';
import type { Address } from './types';

type RawAddress = Partial<Address> & Pick<Address, 'sno'>;
type GetAddressesResponse = {
  addresses: RawAddress[];
};

/**
 * 서버 응답 → 도메인 Address 정규화.
 * `is_default_address` 누락/null → false 보장 (iOS/Android 패리티).
 * 그 외 문자열 필드는 누락 시 빈 문자열로.
 */
const normalizeAddress = (raw: RawAddress): Address => ({
  sno: raw.sno,
  name: raw.name ?? '',
  zipcode: raw.zipcode ?? '',
  address: raw.address ?? '',
  address_detail: raw.address_detail ?? '',
  mobile: raw.mobile ?? '',
  is_default_address: raw.is_default_address ?? false,
});

/**
 * - 배송지 목록 조회
 * - `GET /members/me/addresses/`
 */
export const getAddresses = async (): Promise<{ addresses: Address[] }> => {
  const response = await defaultHttpClient.request<GetAddressesResponse>({
    method: 'GET',
    url: '/api/v2/members/me/addresses/',
  });
  return {
    addresses: response.data.addresses.map(normalizeAddress),
  };
};
